import HeaderData from './HeaderData';

export default HeaderData;
